import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useModal } from '@/providers/modal';
import { WithdrawSelectModal } from '@/modals/WithdrawSelectModal';
import {  MyLink } from '@scramble/ui';
import { APP_LINKS } from '@/helpers/links';
import IconBank from '@scramble/design-system/icons/bank.svg';
import IconChevron from '@scramble/design-system/icons/chevron-right.svg';
import IconPlus from '@scramble/design-system/icons/plus.svg';
import s from './index.module.scss';

export const WithdrawalDestination = ({ selected, accounts, className, onChange }) => {
  const { openSingleModal } = useModal();
  const { t } = useTranslation();

  const onClick = () => {
    openSingleModal(MODAL_IDS.withdraw_select_modal);
  };

  return (
    <div className={classnames(s.wrapper, className)}>
      <div className="f-body-sm f-500">
        {t('withdraw:withdrawal_destination.title')}
      </div>

      {accounts.length ? (
        <div className={s.select} onClick={onClick}>
          <div className={s.header}>
            <div className={s.payment}>
              <img src={IconBank} alt="icon" width={20} height={20} />
              <span className="f-body-md f-500">{selected?.account_number}</span>
            </div>
            <div className={s.icon}>
              <img src={IconChevron} alt="icon" width={20} height={20} />
            </div>
          </div>
          <div className={s.summary}>
            <div className={s.row}>
              <span className="f-body-md">
                {t('withdraw:withdrawal_destination.processing_time')}
              </span>
              <span className="f-body-md f-500">
                {t('withdraw:withdrawal_destination.num_days', {
                  count: '2-4',
                })}
              </span>
            </div>
            <div className={s.row}>
              <span className="f-body-md">
                {t('withdraw:withdrawal_destination.fee')}
              </span>
              <span className="f-body-md f-500">
                {t('withdraw:withdrawal_destination.no_fee')}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <MyLink href={APP_LINKS.bankAccounts} className={s.btn_add}>
          <span className="f-body-md f-500">
            {t('modal:withdraw_select_modal.add_bank_account')}
          </span>
          <span className={s.btn_add_icon}>
            <img src={IconPlus} alt="plus" width={20} height={20} />
          </span>
        </MyLink>
      )}

      <WithdrawSelectModal
        selected={selected}
        accounts={accounts}
        onChange={onChange}
      />
    </div>
  );
};
